module.exports = __webpack_public_path__ + "img/80.79a4f418.png";